// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

export {
  PackageExtractor,
  type LinkCreationMode,
  type IExtractorOptions,
  type IExtractorProjectConfiguration,
  type IExtractorDependencyConfiguration,
  type IExtractorMetadataJson,
  type IProjectInfoJson,
  type IExtractorSubspace
} from './PackageExtractor';

export type { ILinkInfo } from './SymlinkAnalyzer';
